export function getQueryParams (qs): any {
    qs = qs.split('+').join(' ');

    const params = {};
    let tokens;
    const re = /[?&]?([^=]+)=([^&]*)/g;

    while (tokens = re.exec(qs)) {
        params[decodeURIComponent(tokens[1])] = decodeURIComponent(tokens[2]);
    }

    return params;
}



// WEBPACK FOOTER //
// ./app/bundles/enterprise-shop/src/api/utils/get-query-params.ts